
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authenticating",
      function () {
        return require("private-next-pages/authenticating.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authenticating"])
      });
    }
  